<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلترها: </span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue"
							:content="loanType.id === 0 ? items.length : items.filter(x => x.loanModel.id == loanType.id).length || '0'"
							inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست پرونده وام های نماینده'">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search"
					class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="text-right">
								<div>
									<small>شماره وام: </small>
									<small class="grey--text">{{ row.item.code }}</small>
								</div>
								<div>
									<small>عنوان وام: </small>
									<small class="grey--text">{{ row.item.loanModel.title }}</small>
								</div>
								<div>
									<small>نام مشتری: </small>
									<small class="grey--text">{{ row.item.memberModel.fullName }}</small>
								</div>
								<div>
									<small>تاریخ شروع: </small>
									<small class="grey--text">{{ row.item.startDate_Persian.date }}</small>
								</div>
								<div>
									<small>مبلغ وام: </small>
									<small class="grey--text">{{ row.item.amount.toString().toPriceFormat() }}</small>
								</div>
							</td>
							<td class="text-right">
								<div>
									<small>قابل پرداخت: </small>
									<small class="grey--text">{{ row.item.payableAmount.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>تعداد اقساط: </small>
									<small class="grey--text">{{ row.item.month }}</small>
								</div>
								<div>
									<small>مجموع اقساط پرداخت شده: </small>
									<small class="grey--text">{{ row.item.paid.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مانده: </small>
									<small class="grey--text">{{ row.item.remain.toString().toPriceFormat() }}</small>
								</div>
							</td>
							<td class="text-right">
								<div>
									<small>سررسید تسویه با شما: </small>
									<small class="grey--text">{{ row.item.agentDueDate_Persian ?
										row.item.agentDueDate_Persian.date : '' }}</small>
								</div>
								<div>
									<small>سهم شما: </small>
									<small class="grey--text">{{ row.item.agentPrice.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مجموع واریز اسپانسر به شما: </small>
									<small class="grey--text">{{ row.item.sumSponsorPayments.toString().toPriceFormat() }}</small>
								</div>
							</td>
							<td class="text-right">
								<div>
									<small>سررسید تسویه با نماینده: </small>
									<small class="grey--text">{{ row.item.subAgentDueDate_Persian ?
										row.item.subAgentDueDate_Persian.date : '' }}</small>
								</div>
								<div>
									<small>سهم نماینده: </small>
									<small class="grey--text">{{ row.item.subAgentPrice.toString().toPriceFormat() }}</small>
								</div>
								<div>
									<small>مجموع واریز شما به نماینده: </small>
									<small class="info--text" style="cursor: pointer;" @click="subAgentTransactionList(row.item)">
										{{ row.item.sumParentAgentPayments.toString().toPriceFormat() }}
									</small>
									<div class="text-center">
										<v-btn color="secondary" @click="subAgentTransaction(row.item)" x-small>ثبت واریزی</v-btn>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogSubAgentTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifySubAgentTransaction v-if="dialogSubAgentTransaction" :data="selectedTransaction"
							@callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSubAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<SubAgentTransactions v-if="dialogSubAgentTransactionsList" :agent="agent" :userLoan="selectedUserLoan"
						@update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'AgentUserLoans',
		props: {
			agent: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AgentTransactions: () => import('./AgentTransactions.vue'),
			ModifySubAgentTransaction: () => import('./ModifySubAgentTransaction'),
			SubAgentTransactions: () => import('./SubAgentTransactions.vue'),
		},
		data() {
			return {
				selectedTransaction: null,
				selectedUserLoan: null,
				dialogSubAgentTransactionsList: false,
				dialogSubAgentTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'مشخصات وام و مشتری',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 250
					}, {
						text: 'مشخصات بازپرداخت',
						align: 'start',
						sortable: true,
						value: 'paid',
						width: 250
					},
					{
						text: 'نام مشتری',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.fullName',
						width: 150
					},
					{
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					},
					{
						text: 'تاریخ شروع وام',
						align: 'center d-none',
						sortable: true,
						value: 'startDate_Persian',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'قابل پرداخت',
						align: 'center d-none',
						sortable: true,
						value: 'payableAmount',
					},
					{
						text: 'تعداد قسط',
						align: 'center d-none',
						sortable: true,
						value: 'month',
					},
					{
						text: 'عنوان وام',
						align: 'center d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مانده',
						align: 'center d-none',
						sortable: true,
						value: 'remain',
					},
					{
						text: 'تسویه اسپانسر با شما',
						align: 'center',
						sortable: true,
						value: 'userLoan.agentDueDate_Persian',
						width: 200
					},
					{
						text: 'تسویه شما با نماینده',
						align: 'center',
						sortable: true,
						value: 'userLoan.subAgentPrice',
						width: 250
					}
				],
				items: [],
				loanTypes: [],
				loanTypeFilter: '',
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {
			filteredItems() {
				if (!this.loanTypeFilter)
					return this.items
				let clonedItems = []
				clonedItems.push(...this.items)
				clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.loanModel.id) > -1)
				return clonedItems
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/userLoan/GetLoansByAgentId/' + this.agent.id, null)
					.then(response => {
						this.items = response
						this.loanTypes = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.loanModel.id]: obj.loanModel }), {})
						)
						if (this.loanTypes.length) {
							this.loanTypes.push({ id: 0, title: 'همه' })
							this.loanTypeFilter = 0
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			subAgentTransaction(item) {
				this.selectedTransaction = {
					id: emptyId,
					paymentMethod: 2,
					isWithdraw: true,
					userLoan: {
						id: item.id,
						title: `شماره وام: ${item.code}, عنوان: ${item.loanModel.title}`,
						code: item.code,
						subAgentModel: {
							id: this.agent.id,
							businessName: this.agent.businessName,
							mobile: this.agent.mobile,
							firstName: this.agent.firstName,
							bankAccountsJson: this.agent.bankAccountsJson
						}
					},
					amount: Math.max(item.subAgentPrice - item.sumParentAgentPayments, 0),
					maxAmount: item.subAgentPrice - item.sumParentAgentPayments
				}
				this.dialogSubAgentTransaction = true
			},
			callbck_transaction(result) {
				this.dialogSubAgentTransaction = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			subAgentTransactionList(userLoan) {
				this.selectedUserLoan = userLoan
				this.dialogSubAgentTransactionsList = true
			}
		},
	}
</script>
<style></style>
